import { observer } from 'mobx-react-lite';
import ComingSoon from '@/components/general/ComingSoon';

export default observer(function ComingSoonPage() {
    return (
        <div className='container my-10'>
            <ComingSoon />
        </div>
    );
});
